
import React from 'react';
import { Progress } from '@/components/ui/progress';

interface ProgressBarProps {
  current: number;
  total: number;
}

const ProgressBar: React.FC<ProgressBarProps> = ({ current, total }) => {
  const percentage = Math.round((current / total) * 100);
  
  return (
    <div className="w-full">
      <div className="flex justify-between text-sm text-muted-foreground mb-1">
        <span>Question {current} of {total}</span>
        <span>{percentage}% Complete</span>
      </div>
      <Progress 
        value={percentage} 
        className="h-2" 
        indicatorClassName="bg-primary transition-all"
      />
    </div>
  );
};

export default ProgressBar;
